import { API_URLS } from '../config/api';
import { apiPut } from '../utils/apiUtils';

// Handles the repeated apiPut + scene-refresh pattern for both interactive and static scenes.
// Returns saveScene(updatedScene, successMessage) which resolves to true on success, false on error.
export const useSceneUpdate = (novelId, sceneId, isProduction, setScene, setLoading, sceneType = 'interactive') => {
  const getUrl = () => {
    if (sceneType === 'interactive') {
      return isProduction
        ? API_URLS.PRODUCTION_INTERACTIVE_SCENE(novelId, sceneId)
        : API_URLS.BUILDING_INTERACTIVE_SCENE(novelId, sceneId);
    }
    if (sceneType === 'open_world') {
      return isProduction
        ? API_URLS.PRODUCTION_OPEN_WORLD_SCENE(novelId, sceneId)
        : API_URLS.BUILDING_OPEN_WORLD_SCENE(novelId, sceneId);
    }
    return isProduction
      ? API_URLS.PRODUCTION_STATIC_SCENE(novelId, sceneId)
      : API_URLS.BUILDING_STATIC_SCENE(novelId, sceneId);
  };

  const saveScene = async (updatedScene, successMessage = '') => {
    setLoading(true);
    try {
      const response = await apiPut(getUrl(), updatedScene, {}, !!successMessage, successMessage);
      const keyMap = { interactive: 'interactive_scenes', static: 'static_scenes', open_world: 'open_world_interactive_scenes' };
      const key = keyMap[sceneType] || 'interactive_scenes';
      const refreshedScene = response.data[key]?.find(s => s.id === sceneId);
      if (refreshedScene) setScene(refreshedScene);
      return true;
    } catch {
      // Error already shown by toast
      return false;
    } finally {
      setLoading(false);
    }
  };

  return { saveScene };
};
